class Comparison extends HTMLElement {
  constructor() {
    super();

    this.mql = window.matchMedia('(min-width: 750px)');
    this.sliderElement = this.querySelector('.swiper-container');
    this.slides = this.querySelectorAll('.swiper-slide');

    this.slider = null;
    this.flag = null;

    this.options = {
      slidesPerView: 1,
      autoHeight: true,
      loop: false,
      spaceBetween: 0,
      pagination: {
        el: '.comparison__table-rightside--carousel.swiper-pagination',
        type: 'bullets',
      },
    };

    if (!this.mql.matches) this.loadSlider();
    window.addEventListener('resize', this.onResize);
  }

  loadSlider() {
    this.flag = true;
    if (window.vendors && window.vendors.includes('swiper')) {
      this.initSlider();
    } else {
      document.addEventListener('swiper.loaded', () => {
        this.initSlider();
      });
    }
  }

  initSlider() {
    this.slider = new Swiper(this.sliderElement, this.options);
  }

  destroySlider() {
    if (this.slider !== null) {
      this.slider.destroy();
    }
  }

  onResize = () => {
    if (window.matchMedia('(min-width: 750px)').matches) {
      this.destroySlider();
    } else {
      if (this.slider == null || this.slider.destroyed) this.loadSlider();
    }
  };
}

customElements.define('comparison-section', Comparison);
